module.exports = __webpack_public_path__ + "static/moshi_3-c021c48e0e262f36714a5c0917a7db6d.png";